export default __webpack_public_path__ + "static/media/instagram.c0771a8d.svg";